import React from "react";
import { Link } from "react-router-dom";
import Navigation from "../components/Navigation";
import Bounce from "react-reveal/Bounce";

export default function Contact() {
	return (
		<>
			<Navigation />
			<Bounce left>
				<section className="container mx-auto p-5">
					<div className="text-center">
						<h2 className="text-center mt-5 text-4xl">Let's Talk!</h2>
					</div>
					<div className="shadow-lg mt-5 w-2/4 block mx-auto bg-secondColors-primary p-5">
						<div className="flex">
							<h1>Instagram: </h1>
							<Link to="/" className="hover:underline text-blue-500 ml-2">
								https://www.instagram.com/rinosatyaputraa
							</Link>
						</div>
						<div className="flex mt-5">
							<h1>Telegram: </h1>
							<Link to="/" className="hover:underline text-blue-500 ml-2">
								https://t.me/Rinnno
							</Link>
						</div>

						<div className="flex mt-5">
							<h1>Mail: </h1>
							<Link to="/" className="hover:underline text-blue-500 ml-2">
								rinosatyaputra.id@gmail.com
							</Link>
						</div>
					</div>
				</section>
			</Bounce>
		</>
	);
}
